module.exports = __webpack_public_path__ + "static/media/proto.df8bad93.png";


//////////////////
// WEBPACK FOOTER
// ./src/Jiggle/Design/img/proto.png
// module id = 273
// module chunks = 0